import { SUCCESS_MSG, ERROR_MSG, STATUS_CODES } from '@/app/constants/status-constants';
import toastMessages from '@/app/static/js/toast-messages';

export const toastMessageMixins = {
	data() {
		return {
			defaultDuration: 5000,
			toastMessages: toastMessages
		}
	},
	methods: {
		// Success
		showGenericSuccessToast(duration = this.defaultDuration, closeOnClick = true) {
			this.$notify({
				group: 'notifs',
				type: 'success',
				title: SUCCESS_MSG.SUCCESS_TITLE,
				text: SUCCESS_MSG.SUCCESS_TEXT,
				duration
			});
		},
		showCustomSuccessToast(title, text, duration = this.defaultDuration, closeOnClick = true) {
			this.$notify({
				group: 'notifs',
				type: 'success',
				title,
				text,
				duration
			});
		},
		// Info
		showCustomInfoToast(title, text, duration = this.defaultDuration, closeOnClick = true) {
			this.$notify({
				group: 'notifs',
				type: 'info',
				title,
				text,
				duration
			});
		},
		// Warning
		showCustomWarningToast(title, text, duration = this.defaultDuration) {
			this.$notify({
				group: 'notifs',
				type: 'warn',
				title,
				text,
				duration
			});
		},
		// Error
		showAPIErrorToast(title, res, duration = this.defaultDuration) {
			if (res.status === STATUS_CODES.VALIDATION_ERROR || res.status === STATUS_CODES.BAD_REQUEST || res.status === STATUS_CODES.FORBIDDEN || res.status === STATUS_CODES.CONFLICT) {
				for (let errorCount in res.data.errors) {
					this.$notify({
						group: 'notifs',
						type: 'error',
						title,
						text: res.data.errors[errorCount].message || ERROR_MSG.INTERNAL_ERROR_MSG,
						duration
					});
				}
			} else {
				this.$notify({
					group: 'notifs',
					type: 'error',
					title: ERROR_MSG.INTERNAL_ERROR_TITLE,
					text: title || ERROR_MSG.INTERNAL_ERROR_MSG,
					duration
				});
			}
		},
		showGenericErrorToast(duration = this.defaultDuration) {
			this.$notify({
				group: 'notifs',
				type: 'error',
				title: ERROR_MSG.INTERNAL_ERROR_TITLE,
				text: ERROR_MSG.INTERNAL_ERROR_MSG,
				duration
			});
		},
		showCustomErrorToast(title, text, isNoText, duration = this.defaultDuration) {
			if (isNoText) {
				this.$notify({
					group: 'notifs',
					type: 'error',
					title,
					duration
				});
			} else {
				this.$notify({
					group: 'notifs',
					type: 'error',
					title,
					text: text || ERROR_MSG.INTERNAL_ERROR_MSG,
					duration
				});
			}
		}
	}
}
